import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PageTitle from 'components/UI/PageTitle';
import { Link } from 'react-router-dom';

interface MenuItem {
  label: string;
  path: string;
  description: string;
}

interface MenuSection {
  section: string;
  items: MenuItem[];
}

const ADMIN_MENU_SECTIONS: MenuSection[] = [
  {
    section: 'Clientes',
    items: [
      { label: 'Clientes', path: '/clients', description: 'Ver y gestionar clientes' },
      { label: 'Encuestas', path: '/surveys', description: 'Gestionar encuestas de WhatsApp' },
      { label: 'Chat', path: '/demochat', description: 'Chat de demostración' },
      { label: 'Seguros', path: '/broker-dashboard', description: 'Dashboard de broker de seguros' },
      { label: 'Cotizar Seguro', path: '/insurance-quote-form', description: 'Formulario de cotización de seguros' },
    ],
  },
  {
    section: 'Reportería',
    items: [
      { label: 'Dashboard', path: '/dashboard', description: 'Dashboard principal' },
      { label: 'Funnel', path: '/leads', description: 'Ver y gestionar leads' },
      { label: 'Reportes', path: '/reports', description: 'Reportes automáticos' },
      { label: 'Resultado Campañas', path: '/campaigns-stats', description: 'Estadísticas de campañas' },
    ],
  },
  {
    section: 'Ajustes',
    items: [
      { label: 'Agente', path: '/information', description: 'Configuración del agente' },
      { label: 'Autos', path: '/cars', description: 'Gestión de modelos de autos' },
      { label: 'Credenciales', path: '/insurance-credentials', description: 'Credenciales de seguros' },
    ],
  },
  {
    section: 'Admin',
    items: [
      { label: 'Dashboard Interno', path: '/relif-dashboard', description: 'Métricas internas de Relif' },
      { label: 'DB Reader', path: '/db-reader', description: 'Consultas a base de datos' },
      { label: 'Empresas', path: '/businessUnits', description: 'Gestionar unidades de negocio' },
      { label: 'Usuarios', path: '/users', description: 'Gestionar usuarios' },
      { label: 'Monitoreo Salud', path: '/integration-status', description: 'Estado de integraciones' },
      { label: 'URLs Form', path: '/urls-form', description: 'Enviar peticiones HTTP a rutas del backend' },
    ],
  },
];

const Admin = () => {
  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <PageTitle>Admin Panel</PageTitle>
      {ADMIN_MENU_SECTIONS.map((section) => (
        <Box
          key={section.section}
          sx={{
            mb: 4,
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: 'text.secondary',
              fontWeight: 600,
              letterSpacing: 1.2,
            }}
          >
            {section.section}
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{
              mt: 0.5,
            }}
          >
            {section.items.map((item) => (
              <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.path}>
                <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {item.label}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'text.secondary',
                        mb: 2,
                      }}
                    >
                      {item.description}
                    </Typography>
                    <Button component={Link} to={item.path} variant="outlined" fullWidth>
                      Ir a {item.label}
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default Admin;
